"use client"

import { StatCounter } from "@shared/ui/landing/stat-counter"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { coreStats } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function CoreStatsSection() {
  const t = useTranslations("stats")

  return (
    <SectionContainer className="py-12 md:py-16">
      <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
        {coreStats.map((stat) => (
          <div
            key={stat.id}
            className="rounded-2xl border border-brand bg-white p-6 text-center shadow-sm"
          >
            <p className="text-3xl font-bold text-brand md:text-4xl">
              <StatCounter
                value={stat.value}
                prefix={"prefix" in stat ? stat.prefix : undefined}
                suffix={stat.suffix}
                decimals={stat.decimals}
              />
            </p>
            <p className="mt-2 text-sm text-muted-foreground">{t(`${stat.id}.label`)}</p>
          </div>
        ))}
      </div>
    </SectionContainer>
  )
}
